export default "__VITE_ASSET__cba3c194__"